import React from 'react'
import {withTranslation} from "react-i18next";
import { withRouter } from "react-router";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // logErrorToMyService(error, errorInfo);
  }

  handleClick() {
    this.setState({ error: null, errorInfo: null });
    window.location.href = 'https://it.altervista.org/registrazione.php?action=form&atype=blog';
  }
  render() {
    const {t} = this.props;
    if (this.state.errorInfo) {
      return (
        <div>
          <h2>{t('Qualcosa è andato storto')}</h2>
          <p><a onClick={this.handleClick}>{t('Torna indietro')}</a> o inviaci una segnalazione a questa <a href='mailto:feedback_form@altervista.it'>mail</a> </p>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
export default withTranslation()(withRouter(ErrorBoundary))